import { type Grade } from "@core/grades/types";
import { type LessonFilter } from "@core/home/types";
import { BookOpenIcon } from "lucide-react";
import { useLessonsByFilter } from "../hooks/use-lessons-by-filter";
import { LessonCardSkeleton } from "./LessonCardSkeleton";
import { LessonsCarousel } from "./LessonsCarousel";
import { InViewport } from "@core/shared/components/InViewPort";

interface LazySessionsSectionProps {
  grade: Grade;
  filter: LessonFilter;
  className?: string;
}

export function LazySessionsSection({
  grade,
  filter,
  className,
}: LazySessionsSectionProps) {
  const { lessons, isLoading, error } = useLessonsByFilter({
    filter,
    enabled: !!filter.subject && !!filter.grade,
  });

  // Hide section if there's an error
  if (error) {
    return null;
  }

  return (
    <InViewport>
      <div className={className}>
        {isLoading ? (
          <LessonCardSkeleton />
        ) : (
          <LessonsCarousel
            title={grade.name}
            lessons={lessons}
            icon={
              grade.image?.url ? (
                <img
                  src={grade.image.url}
                  alt={grade.name}
                  className="h-5 w-5 sm:h-6 sm:w-6 rounded-full object-cover"
                />
              ) : (
                <BookOpenIcon className="h-5 w-5 sm:h-6 sm:w-6 text-primary-600" />
              )
            }
          />
        )}
      </div>
    </InViewport>
  );
}
